module.exports = __webpack_public_path__ + "img/planta_01.0b5b3e73.jpg";